module.exports = __webpack_public_path__ + "img/11.ee024d5d.jpg";